import { Stack } from "@mui/material";
import * as React from "react";
import FuelCardsReportsTable from "../tables/FuelCardsReportsTable";
import FuelCardsReportsFilter from "../filters/FuelCardsReportsFilter";
import RegistryFuelCardsFilter from "../filters/RegistryFuelCardsFilter";
import RegistryFuelCardsTable from "../tables/RegistryFuelCardsTable";

function RegistryFuelCards() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <RegistryFuelCardsFilter/>
            <RegistryFuelCardsTable/>
        </Stack>
    )
}

export default RegistryFuelCards;